import { hideLoader, showLoader } from "@/redux/actions/loader";
import { noteKeys } from "@/features/notes/api/keyFactory";
import { queryClient } from "@/providers/QueryProvider";
import type { UUID } from "@/core/types";

/**
 * Waits for the BE to finish processing the submitted note before navigating away.
 *
 * TEMPORARY: After note submission the BE needs time to compute derived fields
 * (e.g. `is_cosign_required`). Without this delay the notes list may show stale
 * data and badges like PendingCosignBadge won't appear. The delay + cache
 * invalidation ensures the user sees fresh data on return.
 *
 * TODO: Remove once long-polling is in place.
 */
export async function awaitNotesSummaryRefresh(patientId: UUID, dispatch: (action: any) => any) {
  dispatch(showLoader());
  await new Promise<void>((resolve) => setTimeout(resolve, DELAY_TIME));
  await queryClient.invalidateQueries({ queryKey: noteKeys.summary(patientId) });
  dispatch(hideLoader());
}

const DELAY_TIME = 4_000;
